import * as React from 'react'
import {AttachmentInfo, AttachmentInfos} from '../../core/interfaces/models'
import {CsSelector} from '../../core/components/Controls/CsSelector'
import {AttachmentsViewer} from '../../core/components/Controls/Attachments/AttachmentsViewer2'
import {PlanSelector} from '../App/PlanSelector'
import {Feature} from '../../core/models'
import DatePicker from 'react-datepicker'
import {updateInputData, updateInputDataLayers, validate} from '../../dispatchers/appConstrImportDispatcher'
import {connect} from 'react-redux'
import {IAppStore} from '../../interfaces/reducers'
import {ISourcesDispatcher} from '../../core/interfaces/dispatchers'
import {appSourcesDispatcher} from '../../dispatchers/appSourcesDispatcher'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {IFeatureLayerInfos} from '../../core/interfaces/reducers'
import {IConstrInputData} from '../../interfaces/reducers/IConstrImport'

interface OwnProps {
  inputData: IConstrInputData
  layerInfos: IFeatureLayerInfos
}

interface ParentProps {}

interface DispatchProps extends ISourcesDispatcher {
  updateInputData: typeof updateInputData
  updateInputDataLayers: typeof updateInputDataLayers
  validate: typeof validate
}

type Props = DispatchProps & ParentProps & OwnProps

interface State {}

const ConstrImportInputDataControlC = (props: Props) => {
  const getProjectionSelector = (): JSX.Element => {
    return (
      <CsSelector
        selected={props.inputData.dataCS}
        onChange={s => props.updateInputData({...props.inputData, dataCS: s})}
        className="form-control"
      />
    )
  }

  const getAttachmentsControl = () => {
    const adds: AttachmentInfos = {}
    if (props.inputData.file) {
      adds[props.inputData.file.name] = props.inputData.file
    }
    return (
      <div style={{margin: '5px'}}>
        <AttachmentsViewer
          attachments={{}}
          deletes={{}}
          updates={{}}
          adds={adds}
          acceptTypes={'.dxf'}
          maxNumber={1}
          onAttachmentsChange={changes => {
            const addedFiles = Object.keys(changes.adds)
            let file: AttachmentInfo | undefined
            if (addedFiles.length > 0) {
              file = changes.adds[addedFiles[0]]
            }
            props.updateInputData({...props.inputData, file: file})
          }}
          feature={new Feature({})}
          uploadToArchive={false}
        ></AttachmentsViewer>
      </div>
    )
  }

  const getExecuteButton = () => {
    return (
      <button
        type="button"
        className="button width"
        disabled={!props.inputData.file || !props.inputData.LocalityId || !props.inputData.planName}
        onClick={() => {
          props.validate()
        }}
      >
        Валидирай данните
      </button>
    )
  }

  const getDateEditingDatePicker = (date: Date): JSX.Element => {
    return (
      <DatePicker
        dateFormat={'dd.MM.yyyy'}
        className="form-control"
        selected={date}
        onChange={v => {
          const newDate = new Date(v!)
          ;[0, 0, 0, 0].forEach((v, i) => {
            if (v == undefined) {
              return
            }
            if (i == 0) {
              newDate.setHours(v)
            } else if (i == 1) {
              newDate.setMinutes(v)
            } else if (i == 2) {
              newDate.setSeconds(v)
            } else if (i == 3) {
              newDate.setMilliseconds(v)
            }
          })
          newDate.setMinutes(-newDate.getTimezoneOffset())
          props.updateInputData({...props.inputData, planDate: newDate})
        }}
        isClearable={false}
        showYearDropdown
      />
    )
  }

  const getLocationSelector = () => {
    return (
      <PlanSelector
        hidePlan={true}
        onPlanChange={p => {
          // props.updateInputData({...props.inputData, LocalityId: p ? p.getId() as number: 0})
        }}
        onSettlementsChange={(locs, settlement?: Feature, location?: Feature) => {
          props.updateInputData({
            ...props.inputData,
            settlement,
            location,
            LocalityId: location ? (location.getId() as number) : 0
          })
        }}
      />
    )
  }
  const getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }
  const getPlanNaming = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={props.inputData.planName}
          onChange={e => props.updateInputData({...props.inputData, planName: e.target.value})}
        ></input>
        {getDateEditingDatePicker(props.inputData.planDate)}
      </div>
    )
  }

  const getExpandingLink = () => {
    return (
      <div style={{minHeight: '40px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <a
          href="javascript:;"
          onClick={() => props.updateInputData({...props.inputData, expanded: !props.inputData.expanded})}
        >
          {props.inputData.expanded ? 'По - малко настройки' : 'Повече настройки'}
        </a>
      </div>
    )
  }

  const getLayerMappings = () => {
    const sectionStyle: React.CSSProperties = {
      border: '1px solid #565656',
      borderRadius: '5px',
      boxSizing: 'border-box',
      marginTop: '5px'
    }
    const sectionStyle2: React.CSSProperties = {
      boxSizing: 'border-box',
      padding: '8px'
    }
    const sectionHeaderStyle: React.CSSProperties = {
      padding: '8px',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'cadetblue'
    }
    return (
      <React.Fragment>
        {getExpandingLink()}
        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Матрици</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.MatritzaBlockName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, MatritzaBlockName: e.target.value})
                }
              />,
              'Име на блок за матрица'
            )}

            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.ZoneAttName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, ZoneAttName: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за номер зона</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.FlooringAttName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, FlooringAttName: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за етажност</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.DensityAttName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, DensityAttName: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за плътност на застр.</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.KintAttName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, KintAttName: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за К ИНТ</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.MinGreenAreaAttName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, MinGreenAreaAttName: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за мин. зел. площ</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.ConstructionTypeAttName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, ConstructionTypeAttName: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за тип застрояване</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.SpecificParamsAttName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, SpecificParamsAttName: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за спец. параметри</span>
            )}
          </div>
        </div>
        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Застроителни и ограничителни линии</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.ContructionPolygonLayerName}
                onChange={e =>
                  props.updateInputDataLayers({
                    ...props.inputData.layerNames,
                    ContructionPolygonLayerName: e.target.value
                  })
                }
              />,
              'Име на слой със застроителни линии'
            )}
          </div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.BuildingsLayerName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, BuildingsLayerName: e.target.value})
                }
              />,
              'Име на слой със застроителни линии (допълнителни)'
            )}
          </div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.BuildingsLayerNameDashed}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, BuildingsLayerNameDashed: e.target.value})
                }
              />,
              'Име на слой със застроителни линии (допълнителни) пунктир'
            )}
          </div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.SGRBlockName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, SGRBlockName: e.target.value})
                }
              />,
              'Име на блок с атрибути за ограничителни линии'
            )}
          </div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.SGRZAttName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, SGRZAttName: e.target.value})
                }
              />,
              'Атрибут за височина'
            )}
          </div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.SGRFloorsAttName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, SGRFloorsAttName: e.target.value})
                }
              />,
              'Атрибут за етажност'
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }

  const getClose5cmCheckbox = () => {
    return (
      <input
        type="checkbox"
        checked={props.inputData.cm5Checked}
        onChange={() => props.updateInputData({...props.inputData, cm5Checked: !props.inputData.cm5Checked})}
      ></input>
    )
  }
  const getEncodingSelector = () => {
    return (
      <input
        type="checkbox"
        checked={props.inputData.cp1251}
        onChange={() => props.updateInputData({...props.inputData, cp1251: !props.inputData.cp1251})}
      ></input>
    )
  }
  const getValidationStatusUI = () => {
    if (props.inputData.loading) {
      if (props.inputData.startedImportGuid) {
        return (
          <div className="import-params-success">
            <div>Успешна валидация на входните параметри</div>
            <div>Номер на импорт: {props.inputData.startedImportGuid}</div>
          </div>
        )
      }
      return <div className="import-loading">В процес на валидация на входните параметри...</div>
    } else {
      if (props.inputData.errors.length > 0) {
        const errors: JSX.Element[] = []
        props.inputData.errors.forEach((e, i) => {
          errors.push(<div key={i}>{e}</div>)
        })
        return <div className="import-params-errors">{errors}</div>
      } else if (props.inputData.startedImportGuid) {
        return (
          <div className="import-params-success">
            <div>Успешна валидация на входните параметри</div>
            <div>Номер на импорт: {props.inputData.startedImportGuid}</div>
          </div>
        )
      }
    }
  }

  return (
    <div style={{padding: '10px', boxSizing: 'border-box'} as React.CSSProperties}>
      <div style={{position: 'relative'}}>
        <OverlayLoader show={props.inputData.loading}></OverlayLoader>
        {getContainer(getAttachmentsControl(), 'Прикачете файл', `10px 0px`)}
        {getContainer(getProjectionSelector(), 'Координатна система на данните от файла', `10px 0px`)}
        {getContainer(getLocationSelector(), 'Изберете местност', `10px 0px`)}
        {getContainer(getPlanNaming(), 'Име и дата на плана/изменението', `10px 0px`)}
        {getContainer(getClose5cmCheckbox(), 'Затваряне на квартали под 5см', `10px 0px`)}

        {props.inputData.expanded ? getLayerMappings() : null}
        {getExpandingLink()}
        {getExecuteButton()}
      </div>
      {getValidationStatusUI()}
    </div>
  )
}

const mapStoreToProps = (store: IAppStore) => ({
  inputData: store.constrImport.inputData,
  layerInfos: store.layerInfos.featureLayerInfos
})

export const ConstrImportInputDataControl = connect<OwnProps, DispatchProps, ParentProps>(mapStoreToProps, {
  ...appSourcesDispatcher,
  validate,
  updateInputData,
  updateInputDataLayers
})(ConstrImportInputDataControlC)
